<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'
export default {
    init: async payload => {
        await payload.initTable()

        payload.filters.account = await Common.getAccountId(payload)
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            if (this.isLoading) return

            this.isLoading = true
            this.items = []

            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.patrolPoints.filter}`,
                response => {
                    const page = Array.isArray(response?.results) ? response.results[0] : null
                    const totalCount = page?.totalCount

                    this.items = page?.paginatedResults || []
                    this.totalItems = Array.isArray(totalCount) ? totalCount[0]?.count || 0 : totalCount || 0
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        openCheckPointModal() {
            this.$bvModal.show('checkPointModal')
        },
        onPageChange(newPage) {
            this.currentPage = newPage.currentPage
            this.filters.skip = this.currentPage
            this.filter()
        },
        onPerPageChange(newPerPage) {
            this.paginationOptions.perPage = newPerPage.currentPerPage // Atualize a opção de páginação
            this.filters.limit = newPerPage.currentPerPage // Atualize o limite nos filtros
            this.filters.skip = 0 // Reinicie o offset ao mudar o número de linhas por página
            this.currentPage = 1 // Volte para a primeira página
            this.filter() // Atualize os dados
        },
        selectItem(params) {
            if (this.role === 'AUDITOR') return

            const data = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : { ...this.patrolPointObj }

            delete data.vgt_id
            delete data.originalIndex

            data.account = data?.account?._id || ''
            data.client = data?.client?._id || ''
            data.site = data?.site?._id || ''

            if (!data?.geolocation) {
                data.geolocation = {
                    latitude: '',
                    longitude: '',
                }
            }

            if (!data?.address) {
                data.address = {
                    cep: '',
                    address: '',
                    number: '',
                    complement: '',
                    neighborhood: '',
                    city: '',
                    state: '',
                    ibge: '',
                    gia: '',
                    name: '',
                    lat: '',
                    lng: '',
                }
            }

            if ((!data?.geolocation?.latitude || !data.geolocation?.longitude) && data?.address?.location?.coordinates) {
                const lat = data.address.location.coordinates[1]
                const lng = data.address.location.coordinates[0]

                data.geolocation.latitude = lat
                data.geolocation.longitude = lng
            }

            if (!data?.geolocation?.longitude && data?.address?.lng) {
                data.geolocation.longitude = data.address.lng
            }

            this.data = data

            this.$emit('load-item', data)
        },
        showMap() {
            this.$bvModal.show('mapModal')
        },
        async initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.check.point.column.code'),
                    field: 'patrolPointCode',
                    width: '10%',
                    sortable: true,
                    firstSortType: 'desc',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.name'),
                    field: 'name',
                    width: '25%',
                    sortable: true,
                    firstSortType: 'desc',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.type'),
                    field: 'type',
                    width: '10%',
                    sortable: true,
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                },

                {
                    label: this.$t('str.table.check.point.column.client'),
                    field: 'client',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortClientFn,
                },
                {
                    label: this.$t('str.table.check.point.column.site'),
                    field: 'site',
                    width: '10%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortSiteFn,
                },
                {
                    label: this.$t('str.table.check.point.column.creat.at'),
                    field: 'createDate',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                },
                {
                    label: this.$t('str.table.check.point.column.status'),
                    field: 'status',
                    width: '10%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = {
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'bottom',
                perPageDropdown: [10, 20, 50, 100],
                dropdownAllowAll: false,
                setCurrentPage: 1,
                jumpFirstOrLast: true,
                firstLabel: this.$t('str.table.pagination.first.page'),
                lastLabel: this.$t('str.table.pagination.last.page'),
                nextLabel: this.$t('str.table.pagination.next.page'),
                prevLabel: this.$t('str.table.pagination.prev.page'),
                rowsPerPageLabel: this.$t('str.table.pagination.rows.per.page.lavel'),
                ofLabel: this.$t('str.table.pagination.of.label.page'),
                pageLabel: this.$t('str.table.pagination.page'),
                allLabel: this.$t('str.table.pagination.all.label'),
            }
        },
        changeAccount: async function () {
            const account = this.filters.account

            this.sites = []
            this.filters.client = ''
            this.filters.site = ''

            this.filter()

            this.listClients = await Services.getClientsByAccount(this, account)
        },
        changeClient: async function () {
            const client = this.filters.client

            if (client === '') {
                this.filters.site = ''
            }

            this.filter()

            this.listSites = await Services.getSitesByClient(this, client)
        },
        changeSite: function () {
            this.filter()
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
